import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions, combineActions } from 'redux-actions';
import without from 'lodash/without';
import { commitCollections, commitCollectionsSuccess, commitCollectionsFail, initializeDeviationCollectionsCustom, createCollection, createCollectionSuccess, createCollectionFail, undoChanges, toggleCollection, changeFave, changeFaveSuccess, changeFaveFail, setFaveState, resetJustFaved, setPrivatelyCollectedState } from './actionCreators';
import { reduxKey } from './constants';
import { unloadDuperbrowseItem } from '../../Duperbrowse/redux/actionCreators';
// helper method to set per-deviation states easier
function setDeviationState(state, { payload }, getValues) {
    var _payload_deviation;
    var _payload_deviationId;
    const deviationId = (_payload_deviationId = payload === null || payload === void 0 ? void 0 : payload.deviationId) !== null && _payload_deviationId !== void 0 ? _payload_deviationId : payload === null || payload === void 0 ? void 0 : (_payload_deviation = payload.deviation) === null || _payload_deviation === void 0 ? void 0 : _payload_deviation.deviationId;
    // if the action does not have deviation or deviationId, bail
    if (!deviationId) {
        return state;
    }
    // we use a callback to figure out the next state
    const newValues = getValues(state.deviations[deviationId], payload);
    // if callback returns nothing, means there's nothing to change
    if (!newValues) {
        return state;
    }
    return _object_spread_props(_object_spread({}, state), {
        deviations: _object_spread_props(_object_spread({}, state.deviations), {
            [deviationId]: newValues
        })
    });
}
const handler = handleActions({
    [combineActions(undoChanges, unloadDuperbrowseItem).toString()]: (state, action)=>setDeviationState(state, action, (oldValue)=>oldValue && _object_spread_props(_object_spread({}, oldValue), {
                selectedCollections: oldValue.savedCollections
            })),
    [initializeDeviationCollectionsCustom.toString()]: (state, action)=>{
        if (!action.payload) {
            return state;
        }
        const { ignorePreselectedCollections, isPrivateCollections } = action.payload;
        return _object_spread_props(_object_spread({}, setDeviationState(state, action, (oldValue, payload)=>({
                isInitializedForCollecting: !isPrivateCollections ? true : !!(oldValue === null || oldValue === void 0 ? void 0 : oldValue.isInitializedForCollecting),
                isInitializedForPrivateCollecting: isPrivateCollections ? true : !!(oldValue === null || oldValue === void 0 ? void 0 : oldValue.isInitializedForPrivateCollecting),
                isFavourite: !isPrivateCollections && payload.collectionids.length > 0,
                isPrivatelyCollected: isPrivateCollections && payload.collectionids.length > 0,
                isLoading: false,
                faveCount: payload.faveCount,
                selectedCollections: ignorePreselectedCollections || isPrivateCollections ? [] : payload.collectionids,
                selectedPrivateCollections: ignorePreselectedCollections || !isPrivateCollections ? [] : payload.collectionids,
                savedCollections: payload.collectionids,
                justFaved: false
            }))), {
            isNewCollectionSaving: false
        });
    },
    [toggleCollection.toString()]: (state, action)=>setDeviationState(state, action, (oldValue, payload)=>{
            if (!oldValue) {
                return;
            }
            const selectedCollectionsKey = payload.isPrivateCollections ? 'selectedPrivateCollections' : 'selectedCollections';
            const selected = oldValue[selectedCollectionsKey];
            // if the folder was selected, we remove it; otherwise add it
            const newSelected = selected.includes(payload.folderId) ? without(selected, payload.folderId) : [
                ...selected,
                payload.folderId
            ];
            return _object_spread_props(_object_spread({}, oldValue), {
                [selectedCollectionsKey]: newSelected
            });
        }),
    [commitCollections.toString()]: (state, action)=>setDeviationState(state, action, (oldValue)=>oldValue && _object_spread_props(_object_spread({}, oldValue), {
                isLoading: true
            })),
    [commitCollectionsSuccess.toString()]: (state, action)=>{
        return setDeviationState(state, action, (oldValue, { folderIds })=>oldValue && _object_spread_props(_object_spread({}, oldValue), {
                selectedCollections: folderIds,
                savedCollections: folderIds,
                isLoading: false
            }));
    },
    [commitCollectionsFail.toString()]: (state, action)=>setDeviationState(state, action, (oldValue)=>oldValue && _object_spread_props(_object_spread({}, oldValue), {
                isLoading: false
            })),
    [createCollection.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isNewCollectionSaving: true
        }),
    [createCollectionSuccess.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isNewCollectionSaving: false
        }),
    [createCollectionFail.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isNewCollectionSaving: false
        }),
    [setPrivatelyCollectedState.toString()]: (state, action)=>setDeviationState(state, action, (oldValue)=>oldValue && _object_spread_props(_object_spread({}, oldValue), {
                isPrivatelyCollected: action.payload.to
            })),
    [combineActions(changeFave, setFaveState).toString()]: (state, action)=>setDeviationState(state, action, (oldValue, payload)=>{
            const { deviation, deviation: { isFavourited }, to } = payload;
            // sometimes we only want to change the favedness in the store
            // eg. when the collections are being updated
            // this means we can skip changing a bunch of values
            const isPureSet = action.type === setFaveState.toString();
            if (isPureSet && !oldValue) {
                return;
            }
            const isFavouritedNow = oldValue && oldValue.isFavourite !== undefined ? oldValue.isFavourite : isFavourited || false;
            const willBeFavourited = to === undefined ? !isFavouritedNow : to;
            if (isFavouritedNow === willBeFavourited) {
                // nothing to do
                return oldValue;
            }
            const favesNow = oldValue && oldValue.faveCount !== undefined ? oldValue.faveCount : deviation.stats && deviation.stats.favourites || 0;
            return _object_spread_props(_object_spread({}, oldValue), {
                isFavourite: willBeFavourited,
                justFaved: !isPureSet && !isFavouritedNow && willBeFavourited,
                faveCount: Math.max(favesNow + (willBeFavourited ? 1 : -1), 0),
                isLoading: !isPureSet,
                isInitializedForCollecting: isPureSet ? oldValue.isInitializedForCollecting : false,
                isInitializedForPrivateCollecting: isPureSet ? oldValue.isInitializedForPrivateCollecting : false,
                savedCollections: isPureSet ? oldValue.savedCollections : [],
                selectedCollections: isPureSet ? oldValue.selectedCollections : [],
                selectedPrivateCollections: isPureSet ? oldValue.selectedPrivateCollections : []
            });
        }),
    [changeFaveSuccess.toString()]: (state, action)=>setDeviationState(state, action, (oldValue)=>oldValue && _object_spread_props(_object_spread({}, oldValue), {
                isLoading: false
            })),
    [changeFaveFail.toString()]: (state, action)=>setDeviationState(state, action, (oldValue)=>oldValue && _object_spread_props(_object_spread({}, oldValue), {
                isFavourite: !oldValue.isFavourite,
                justFaved: false,
                faveCount: oldValue.faveCount + (oldValue.isFavourite ? -1 : 1)
            })),
    [resetJustFaved.toString()]: (state, action)=>setDeviationState(state, action, (oldValue)=>oldValue && _object_spread_props(_object_spread({}, oldValue), {
                justFaved: false
            }))
}, {
    deviations: {},
    isNewCollectionSaving: false
});
export default {
    [reduxKey]: handler
};

//# sourceMappingURL=reducer.js.map